var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", { staticClass: "video-lecture-details" }, [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6 col-lg-7" }, [
            _vm.course
              ? _c(
                  "h5",
                  {
                    staticClass:
                      "action-header video-course-details__header-title typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile",
                    attrs: {
                      title:
                        _vm.$t("video_lectures.sub_header.video_courses") +
                        " > " +
                        _vm.course.title +
                        " > " +
                        _vm.lectureTitle
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("video_lectures.sub_header.video_courses")
                        ) +
                        " > " +
                        _vm._s(_vm.course.title) +
                        " > " +
                        _vm._s(_vm.lectureTitle) +
                        "\n        "
                    )
                  ]
                )
              : _c(
                  "h5",
                  {
                    staticClass:
                      "action-header video-lecture-details__header-title typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile",
                    attrs: {
                      title:
                        _vm.$t("video_lectures.sub_header.video_lectures") +
                        " > " +
                        _vm.lectureTitle
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$t("video_lectures.sub_header.video_lectures")
                        ) +
                        " > " +
                        _vm._s(_vm.lectureTitle) +
                        "\n        "
                    )
                  ]
                )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 col-lg-5 hidden-sm-down" }, [
            _c(
              "div",
              { staticClass: "action-btn-row" },
              [
                _c(
                  "router-link",
                  {
                    staticClass: "btn btn-primary float-right ml-1 mr-1",
                    attrs: { to: _vm.$route.path + "/edit" }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("video_lectures.video_lecture.edit")) +
                        "\n          "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-primary float-right mr-1",
                    on: {
                      click: function($event) {
                        return _vm.$root.$emit(
                          "show::modal",
                          "remove-video-lecture-modal"
                        )
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("publishers.headers.actions.remove")) +
                        "\n          "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          {
            staticClass: "container mw-620 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("common.loading")) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              )
            ])
          ]
        )
      : _c(
          "div",
          {
            staticClass: "container mw-620 mt-4 pt-1",
            attrs: { slot: "layout-body" },
            slot: "layout-body"
          },
          [
            _vm.videoEmbed
              ? _c(
                  "div",
                  {
                    staticClass:
                      "video-lecture-details__video-preview text-center w-100"
                  },
                  [
                    _c("div", {
                      staticClass: "w-100",
                      domProps: { innerHTML: _vm._s(_vm.videoEmbed) }
                    })
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _vm.lecture
              ? _c("div", { staticClass: "video-lecture-details__meta" }, [
                  _c("div", { staticClass: "typography--title mt-3" }, [
                    _vm._v("\n        " + _vm._s(_vm.lectureTitle) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary mt-2"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.domain && _vm.domain.name) +
                          " " +
                          _vm._s(_vm.domainConcept && _vm.domainConcept.name) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary mb-3"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.getGradeLabel(_vm.lecture)) +
                          " " +
                          _vm._s(_vm.getSubjectLabel(_vm.lecture)) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-3 typography--color-secondary mb-3"
                    },
                    [
                      _c("span", { staticClass: "mr-3" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.terms.view_count")) +
                            " " +
                            _vm._s(_vm.lecture.view_count) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "mr-3" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.terms.like")) +
                            " " +
                            _vm._s(_vm.lecture.like_count) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.getShareLevelLabel(
                                _vm.lecture.share_level || 2
                              )
                            ) +
                            "\n        "
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _vm.lectureDescription
                    ? _c("div", {
                        staticClass: "typography--body-1 break-word-all mt-3",
                        domProps: { innerHTML: _vm._s(_vm.lectureDescription) }
                      })
                    : _c(
                        "div",
                        {
                          staticClass:
                            "typography--body-1 typography--color-disabled mt-3"
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("common.terms.no_description")) +
                              "\n      "
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-3 typography--color-disabled mb-5"
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("common.terms.posted_date")) +
                          ":\n        " +
                          _vm._s(_vm._f("datetime")(_vm.lecture.created_at)) +
                          "\n      "
                      )
                    ]
                  )
                ])
              : _vm._e()
          ]
        ),
    _vm._v(" "),
    _c(
      "div",
      { attrs: { slot: "modal-area" }, slot: "modal-area" },
      [
        _c(
          "BasicModal",
          {
            attrs: {
              id: "remove-video-lecture-modal",
              title: _vm.$t("video_lectures.modals.remove_lecture.title")
            },
            on: {
              ok: function($event) {
                return _vm.removeLecture()
              }
            }
          },
          [
            _c("div", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("video_lectures.modals.remove_lecture.message")
                )
              }
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-78d42586", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78d42586","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/video-lectures/views/VideoLectureDetails.vue
// module id = 2qX0
// module chunks = 1